import * as React from 'react';
import { connect } from 'react-redux';
import { AppStates } from '../../reducers/app';
import { ReflowableContentSettingState } from '../../reducers/ui/reflowableContentSetting';
import { Dispatch, Action } from 'redux';
import IconButton from '../common/IconButton';
import { getBasePath } from '../../utils/browser';
import ToolIconRadioButtonSet from '../common/ToolIconRadioButtonSet';
import VerticalBorder from '../common/VerticalBorder';
import SNEColorSelectButton from './SNEColorSelectButton';
import SNEColorSampleBox from './SNEColorSampleBox';
import { setCustomPageColorIndex } from '../../actions/PreferenceAction';
import { PreferenceState } from '../../reducers/preference';

interface ReflowableContentSNEUserPatternSettingprops extends ReflowableContentSettingState {
  readonly preference: PreferenceState;
  readonly dispatch: Dispatch<Action>;
  readonly onBackButtonClick: () => void;
}

const colorPanelStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const toolButtonSetStyle: React.CSSProperties = {
  width: '344px',
  height: '276px',
  padding: '2px',
  boxSizing: 'border-box',
  backgroundColor: '#dadabc',
};

const textImageStyle: React.CSSProperties = {
  width: '70px',
  height: '40px',
  marginBottom: '13px',
  marginTop: '17px',
};

const bottomConteiner: React.CSSProperties = {
  marginRight: '28px',
  marginLeft: '28px',
  marginBottom: '28px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent :'space-between',
};

const resultConteiner: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
};

const resultTextImageStyle: React.CSSProperties = {
  height: '71px',
  width: '158px',
  marginLeft: '75px',
};

const ReflowableContentSNEUserPatternSetting:React.SFC<
  ReflowableContentSNEUserPatternSettingprops
> = React.memo((props) => {
  const {
    dispatch,
    onBackButtonClick,
    preference,
  } = props;

  const textColorButtons: JSX.Element[] = [];
  for (let i = 0; i < 80; i += 1) {
    const num = `${i + 1}`;

    textColorButtons.push(
      <SNEColorSelectButton
        key={num}
        active={preference.customPageColorIndex.textColorIndex === i}
        colorIndex={i}
        onClick={() => {
          dispatch(setCustomPageColorIndex({
            backgroundColorIndex: preference.customPageColorIndex.backgroundColorIndex,
            textColorIndex: i,
          }));
        }}
      />,
    );
  }

  const bgColorButtons: JSX.Element[] = [];
  for (let i = 0; i < 80; i += 1) {
    const num = `${i + 1}`;

    bgColorButtons.push(
      <SNEColorSelectButton
        key={num}
        active={preference.customPageColorIndex.backgroundColorIndex === i}
        colorIndex={i}
        onClick={() => {
          dispatch(setCustomPageColorIndex({
            backgroundColorIndex: i,
            textColorIndex: preference.customPageColorIndex.textColorIndex,
          }));
        }}
      />,
    );
  }

  const baseDir = getBasePath();
  const textColorTitleSrc = `${baseDir}/images/setting-popup/text/text_font_color.png`;
  const backGroundColorTitleSrc = `${baseDir}/images/setting-popup/text/text_Background color.png`;
  const resutlDescriptionSrc =
    `${baseDir}/images/setting-popup/text/text_color_select_description.png`;

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div style={{ ...colorPanelStyle, marginRight: '20px', marginLeft: '28px' }}>
          <img src={backGroundColorTitleSrc} style={textImageStyle} />
          <ToolIconRadioButtonSet style={toolButtonSetStyle}>
            {bgColorButtons}
          </ToolIconRadioButtonSet>
        </div>
        <VerticalBorder
          style={{
            marginTop: '50px',
            marginBottom: '8px',
            height: '317px',
            backgroundColor: '#cbcbcb',
          }}
        />
        <div style={{ ...colorPanelStyle, marginRight: '28px', marginLeft: '20px' }}>
          <img src={textColorTitleSrc} style={textImageStyle} />
          <ToolIconRadioButtonSet style={toolButtonSetStyle}>
            {textColorButtons}
          </ToolIconRadioButtonSet>
        </div>
      </div>
      <div style={bottomConteiner}>
        <div style={resultConteiner}>
          <img src={resutlDescriptionSrc} style={resultTextImageStyle} />
          <SNEColorSampleBox
            textColorIndex={preference.customPageColorIndex.textColorIndex}
            backgroundColorIndex={preference.customPageColorIndex.backgroundColorIndex}
           />
        </div>
        <div style={{ marginRight: '18px', height:'71px', display: 'flex',
          alignItems:'center' }}>
          <IconButton
            title="戻る"
            imagePath="images/setting-popup/sne/btn_color_select_return"
            style={{ width: '100px', height:'43px' }}
            svgStyle={{ width: '100px', height:'43px' }}
            margin={false}
            onClick={onBackButtonClick}
          />
        </div>
      </div>
    </>
  );
});

const mapStateToProps = (appStates: AppStates) => ({
  ...appStates.ui.reflowableContentSetting,
  preference: appStates.preference,
});

export default connect(mapStateToProps)(ReflowableContentSNEUserPatternSetting);
